function capitalize(text) {
  return text
    ?.split(' ')
    ?.map((a) => a?.charAt(0)?.toUpperCase() + a.substring(1))
    ?.join(' ');
}

export default capitalize;
